export enum DeviceType {
  Unknown = 'Unknown',
  Scanner = 'Scanner',
  Printer = 'Printer',
  CCL = 'CCL',
  CashDrawer = 'CashDrawer',
  Scale = 'Scale',
  CustomerDisplay = 'CustomerDisplay',
  MICR = 'MICR',
}
